import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Plus, List } from "lucide-react";
import { CampaignCreate } from "@/pages/perkpoint/campaign/CampaignCreate";
import { CampaignAllCampaigns } from "@/pages/perkpoint/campaign/CampaignAllCampaigns";

export default function GiftCardCampaign() {
  const [activeTab, setActiveTab] = useState<string>("all-campaigns");

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Campaign</h1>
          <p className="text-muted-foreground">
            Manage and track campaign activities for Gift OS
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="all-campaigns" className="text-sm">
            <List className="h-4 w-4 mr-2" />
            All Campaigns
          </TabsTrigger>
          <TabsTrigger value="create" className="text-sm">
            <Plus className="h-4 w-4 mr-2" />
            Create Campaign
          </TabsTrigger>
        </TabsList>

        <TabsContent value="all-campaigns" className="space-y-6 mt-6">
          <CampaignAllCampaigns />
        </TabsContent>

        <TabsContent value="create" className="space-y-6 mt-6">
          <CampaignCreate variant="gift-os" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
